import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { DialogDeleteGenericComponent } from '@app/shared/components/dialog-delete-generic/dialog-delete-generic.component';
import { NotificationType } from '@app/shared/interfaces';
import { Tax } from '@app/shared/models/tax';
import { TaxService } from '@app/shared/services/taxes/tax.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';

@Component({
  standalone: false,
  selector: 'sbnb-list-taxes',
  templateUrl: './list-taxes.component.html',
  styleUrls: ['./list-taxes.component.scss'],
})
export class ListTaxesComponent implements OnInit {
  loading = false;
  taxes: Tax[] = [];

  constructor(
    private taxService: TaxService,
    private router: Router,
    private toast: ToastNotificationsService,

    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getTaxes();
  }

  getTaxes() {
    this.loading = true;
    this.taxService.getTaxes().subscribe((taxes) => {
      this.taxes = taxes;
      this.loading = false;
    });
  }

  addTax() {
    this.router.navigate(['/settings/taxes/name']);
  }

  update(tax: Tax) {
    this.router.navigate(['/settings/taxes/name'], {
      queryParams: { id: tax.uuid },
    });
  }

  deleteTaxPrompt(tax) {
    const dialogRef = this.dialog.open(DialogDeleteGenericComponent, {
      width: '720px',
      data: {
        name: tax.name,
        list: [
          'This tax will continue to be collected for existing and pending reservations.',
          'This tax will no longer be collected for any new reservations.',
        ],
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteTax(tax.uuid);
      }
    });
  }

  deleteTax(uuid) {
    this.taxService.deleteTax(uuid).subscribe((response) => {
      this.getTaxes();
      this.toast.open(`Tax deleted successfully`, 'Dismiss', NotificationType.Error);
    });
  }
}
